export default {
  toDayValues(schedulingDays, { days }, translate) {
    return Object.values(days).map(day => ({
      value: day.id,
      text: translate(day.text),
      selected: !!schedulingDays[day.id]
    }))
  },

  toHourValues(schedulingHours, { hours }, translate) {
    return Object.values(hours).map(hour => {
      const from = hour.schedule.from
      const to = hour.schedule.to
      const text = translate(hour.text)
      return {
        value: hour.id,
        text: `${text} (${from} - ${to})`,
        selected: !!schedulingHours[hour.id]
      }
    })
  },

  toScheduling(schedulingValues) {
    return schedulingValues
      .filter(value => value.selected)
      .reduce((acc, item) => {
        acc[item.value] = true
        return acc
      }, {})
  }
}
